import PropTypes from 'prop-types'
import React from 'react'

const Checkbox = ({
  checked = false,
  onChange,
  disabled = false,
  className = '',
  checkboxClassName = '',
  checkClassName = '',
}) => {
  return (
    <span className={`glg-simple-checkbox ${disabled ? 'glg-simple-checkbox--disabled' : ''} ${className}`}>
      <input
        type="checkbox"
        checked={checked}
        onChange={onChange}
        disabled={disabled}
        className="checkbox-input"
      />
      <div className={`checkbox-box ${checked ? 'checkbox-box--checked' : ''} ${checkboxClassName}`}>
        {checked && (
          <svg
            className={`checkbox-check ${checkClassName}`}
            viewBox="0 0 12 10"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1 4.27273L4.125 7L11 1"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        )}
      </div>
    </span>
  )
}

Checkbox.propTypes = {
  checked: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  checkboxClassName: PropTypes.string,
  checkClassName: PropTypes.string,
}

export default Checkbox
